import React, { useEffect, useState } from 'react';
import FeeModal from '../fee-modal/FeeModal';
import OrderController from '@/services/OrderController';
import { toast } from 'react-hot-toast';
import { isNumericFee } from '@/utils/validation';

// mode 'fee' is the rider's fee, mode 'shopFee' is what the shop is charged.
// They are separate amounts on the order and have their own price lists.
const MODES = {
	fee: {
		title: 'Αλλαγή προμήθειας',
		pickError: 'Πρέπει να διαλέξεις προμήθεια',
		numericError: 'Η προμήθεια πρέπει να είναι νούμερο',
		success: 'Η αλλαγή προμήθειας έγινε',
		listKey: 'feeList',
		save: (orderId, value) => OrderController.updateCompletedOrderFee(orderId, value),
	},
	shopFee: {
		title: 'Αλλαγή χρ. κατ.',
		pickError: 'Πρέπει να διαλέξεις χρέωση',
		numericError: 'Η χρέωση πρέπει να είναι νούμερο',
		success: 'Η αλλαγή χρέωσης έγινε',
		listKey: 'shopFeeList',
		save: (orderId, value) => OrderController.updateCompletedOrderShopFee(orderId, value),
	},
};

const ChangeFeeModal = ({ order, onClose, mode = 'fee' }) => {
	const config = MODES[mode] || MODES.fee;

	console.log('config:', config, mode);

	const [feeList, setFeeList] = useState(null);
	const [selectedFeeIdx, setSelectedFeeIdx] = useState(null);
	const [customFee, setCustomFee] = useState('');

	useEffect(() => {
		getShopFeeList();
		// setFeeList(order?.shop?.feeList || null)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [order, mode]);

	const getShopFeeList = async () => {
		const res = await OrderController.getShopFeeList(order?.sh?.id);
		if (res?.[config.listKey]) {
			setFeeList(res[config.listKey]);
		}
	};

	const changeSelectedFeeIdx = idx => {
		setSelectedFeeIdx(idx);
		// setCustomFee(null);
		setCustomFee('');
	};

	const changeCustomFee = fee => {
		setSelectedFeeIdx(null);
		// setValue('customFee', fee);
		setCustomFee(fee);
		// setCustomFee('');
	};

	const onSave = async () => {
		try {
			let fee;
			// const { customFee } = getValues();
			if (feeList) {
				if (!customFee && !(selectedFeeIdx >= 0)) {
					toast.error(config.pickError);
					return;
				}

				if (customFee?.length > 0) {
					if (!isNumericFee(customFee)) {
						toast.error(config.numericError);
						return;
					}
				}

				fee = selectedFeeIdx !== null ? feeList[selectedFeeIdx] : customFee;
			}

			// without the await this resolved to a pending promise, so the error
			// branch below could never run and every failure looked like a success
			const res = await config.save(order.id, parseFloat(fee));

			if (!res?.error) {
				toast.success(config.success);
				setFeeList(null);
				setSelectedFeeIdx(null);
				// setCustomFeeSelected(false);
				setCustomFee('');
				onClose();
				// onCloseCompleteModal();
			} else {
				console.log('on change fee err 1', res?.code);
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
				// toast.error(`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${typeof res.error === 'string' ? ` ${res.error}` : ''}${res?.code ? ` (${res.code})` : ''}`)
			}
		} catch (e) {
			console.log('on change fee err 2: ', e);
		}
	};
	return (
		<FeeModal
			title={config.title}
			label={config.title}
			onClose={onClose}
			feeList={feeList}
			changeCustomFee={changeCustomFee}
			selectedFeeIdx={selectedFeeIdx}
			changeSelectedFeeIdx={changeSelectedFeeIdx}
			customFee={customFee}
			onSave={onSave}
			saveText='Αλλαγή'
		/>
	);
};

export default ChangeFeeModal;
